import { Constants } from '@pwc/pwc-deals-web-common';
import { get, cloneDeep } from 'lodash';
import { getPptLibraryItemsByGroup } from '../../../contentLibrary/libraryItemService';

class PowerPointLibraryItem {
  constructor(libraryItem, formatType = 'SVG') {
    this.data = JSON.parse(libraryItem.data);
    this.type = libraryItem.type;
    this.libraryItemType = Constants.LIBRARY_ITEM_TYPES.POWER_POINT_GROUP.value;
    this.formatType = formatType;
    this.service = getPptLibraryItemsByGroup;
    this.libraryItem = libraryItem;
  }

  extractSourceName() {
    return {
      source: `Slide ${this.data.slideNumber || this.data.SlideNumber} ${
        this.data.groupName || this.data.GroupName
      }`,
    };
  }

  getRequestPayload() {
    const slideNumber = get(this.data, 'SlideNumber');
    const data = {
      id: this.libraryItem.id,
      name: this.libraryItem.name,
      type: this.libraryItem.type,
      slideNumber,
      data: {
        formatType: this.formatType,
        groupName: get(this.data, 'GroupName'),
        slideNumber,
      },
    };

    return {
      ...cloneDeep(this.data),
      pptLibraryItems: [data],
    };
  }
}

export default PowerPointLibraryItem;
